<script lang="ts">
  import type { StopJson } from '../../types/StopJson';

  interface Properties {
    stop: StopJson;
    /** Text used when `stop.name` is empty (synthetic origin/destination endpoints). */
    fallback: string;
    /** Fires with `stop` when the chip is clicked; the chip renders as plain text
     *  when omitted or when `stop.name` is empty. */
    onOpen?: (stop: StopJson) => void;
  }

  const { stop, fallback, onOpen }: Properties = $props();

  /** Emits the click intent so the parent can switch tabs and load the board. */
  function activate(): void {
    onOpen?.(stop);
  }
</script>

{#if stop.name}
  <button type="button" class="stop-chip stop-chip-link" onclick={activate}>
    {stop.name}
  </button>
{:else}
  <span class="stop-chip">{fallback}</span>
{/if}

<style>
  .stop-chip {
    color: var(--color-fg);
  }

  .stop-chip-link {
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    color: var(--color-primary);
    cursor: pointer;
    text-align: left;
  }

  .stop-chip-link:hover,
  .stop-chip-link:focus-visible {
    text-decoration: underline;
  }
</style>
